/**
 * Shows a searchbar with search icon and close ToolbarButton, with white background
 */

import React from 'react';

export default class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || '',
        };

        this.debouncedTriggerChangeEvent = _.debounce(this.triggerChangeEvent.bind(this), 500);
    }
    get value() {
        return this.state.value;
    }
    set value(value) {
        this.setState({value});
    }
    componentDidMount() {
        this.state.mounted = true;
        this.input.focus();
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        return (
            <div className="SearchBar2">
                <input
                    type="text"
                    ref={el => (this.input = el)}
                    placeholder={this.props.placeholder || this.props.i18n['label.zoken']}
                    value={this.state.value}
                    onChange={this.handleInputChange.bind(this)}
                />
                <button type="button" onClick={this.handleCloseSearchBar.bind(this)} />
            </div>
        );
    }
    handleInputChange(event) {
        let value = event.target.value.trim();
        if (value != this.state.value) {
            this.setState({value});
            this.debouncedTriggerChangeEvent(value);
        }
    }
    handleCloseSearchBar() {
        this.props.onClose();
    }
    triggerChangeEvent(value) {
        if (this.state.mounted) {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        }
    }
}
